import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { urlAPI } from "../../services/api.services";

import { ClientSlider } from "../../components/commons/swiper";
import ellipse1 from "../../assets/images/Ellipse1.png";
import ellipse2 from "../../assets/images/Ellipse2.png";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { FaUser } from "react-icons/fa6";
import { Helmet } from "react-helmet";
import { useAppContext } from "../../context/AppContext";

function SingleNews() {
  const { id } = useParams();
  const { landingpage, benefit, blog, social } = useAppContext();

  const [landing, setLanding] = useState("");
  const [contactVal, setContactVal] = useState([]);

  useEffect(() => {
    if (landingpage) setLanding(landingpage)
    if (social) setContactVal(social)
  }, [landingpage, social]);

  const formatDateLong = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <>
      <div id="project">
        {blog?.blog?.length >= 1 && (
          <>
            {blog?.blog
              ?.filter((item) => item.slug === id)
              .map((item, index) => (
                <>
                  <Helmet>
                    <title>{item?.meta_title}</title>
                    <meta name="description" content={item?.meta_description} />
                    <meta name="keywords" content={item?.keywords} />
                    <link
                      rel="canonical"
                      href={`https://www.prismamultimedia.com/blog/${item?.id}`}
                    />
                  </Helmet>
                  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20 lg:mb-32">
                    <div class="max-w-3xl mx-auto">
                      <div className="pt-8 pb-5">
                        <nav
                          className="block lg:hidden text-sm text-gray-600 mb-3"
                          aria-label="Breadcrumb"
                        >
                          <ol className="flex items-center flex-wrap">
                            <li>
                              <Link to="/" className="hover:underline text-blue-600">Home</Link>
                            </li>
                            <li>
                              <IoIosArrowForward className="mx-2 text-gray-400" />
                            </li>
                            <li>
                              <Link to="/blog" className="hover:underline text-blue-600">Blog</Link>
                            </li>
                            <li>
                              <IoIosArrowForward className="mx-2 text-gray-400" />
                            </li>
                            <li className="text-gray-800">{item.title}</li>
                          </ol>
                        </nav>
                        <h1 className="text-3xl font-bold mb-2">{item.title}</h1>
                        <div className="flex flex-wrap gap-4">
                          <p className="text-gray-500 text-sm">
                            Published on{" "}
                            <time dateTime={item.created_at}>
                              {formatDateLong(item.created_at)}
                            </time>
                          </p>
                          <p className="text-gray-500 text-sm">
                            Author :{" "}
                            <a
                              href={`/blog/author/${item.author_id}`}
                              className="hover:text-blue-500 hover:underline"
                            >
                              {item.author.name}
                            </a>
                          </p>
                        </div>
                        <nav
                          className="hidden lg:block text-sm text-gray-600 mt-4 mb-1"
                          aria-label="Breadcrumb"
                        >
                          <ol className="flex items-center flex-wrap">
                            <li>
                              <Link to="/" className="hover:underline text-blue-600">Home</Link>
                            </li>
                            <li>
                              <IoIosArrowForward className="mx-2 text-gray-400" />
                            </li>
                            <li>
                              <Link to="/blog" className="hover:underline text-blue-600">Blog</Link>
                            </li>
                            <li>
                              <IoIosArrowForward className="mx-2 text-gray-400" />
                            </li>
                            <li className="text-gray-800">{item.title}</li>
                          </ol>
                        </nav>
                      </div>
                      <img
                        src={urlAPI + item.image_url}
                        alt={item.image_alt || item.meta_title}
                        className="w-full h-auto mb-8 rounded-lg"
                      />
                      <div class="prose prose-sm sm:prose lg:prose-lg xl:prose-xl mx-auto">
                        <div
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      </div>

                      <hr className="border-t border-gray-200 py-6 w-full mt-4" />

                      <div className="flex items-center gap-4 text-center md:text-left">
                        {/* Icon/User Image */}
                        <div className="w-24 h-24 rounded-full bg-gray-400 flex items-center justify-center overflow-hidden">
                          {/* <p>
                                <FaUser />
                              </p> */}
                          {item?.author?.image_url ? (
                            <img
                              src={urlAPI + item?.author?.image_url}
                              alt={item?.author?.image_alt || item?.author?.name}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            // <img
                            //   src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgP800jb2DE6yqLBxVbe8SJINe29Y4ruA6hA&s"
                            //   alt="Author"
                            //   className="w-full h-full object-cover"
                            // />

                            <FaUser className="text-white text-6xl" />
                          )}
                        </div>

                        {/* Name & Description */}
                        <div className="flex flex-col gap-2">
                          <div>
                            <h2
                              onClick={() =>
                                (window.location.href = `/blog/author/${item.author_id}`)
                              }
                              className="text-lg font-semibold text-gray-800 hover:text-blue-500 hover:underline cursor-pointer"
                            >
                              {item?.author?.name}
                            </h2>
                            {/* <div className="flex items-center gap-2">
                          <p>{item?.author?.email}</p>
                          <p>|</p>
                          <p>Role : {item?.author?.type}</p>
                        </div> */}
                          </div>
                          <div
                            className=" text-gray-600 text-sm lg:text-base max-w-md"
                            dangerouslySetInnerHTML={{
                              __html:
                                item?.author?.description !== null
                                  ? item?.author?.description
                                  : "-",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
          </>
        )}

        <section id="contact-pricing">
          <div className="relative flex py-5 items-center">
            <div className="flex-grow border-t border-gray-400"></div>
            <span className="flex-shrink mx-4 w-3/5 rounded-xl lg:px-10 py-5 lg:py-14 border-2 border-abumud">
              <div className="lg:flex flex-row justify-between items-center">
                <div className="basis-1/2 text-base md:text-3xl tracking-wider font-semibold text-center lg:text-left mb-3 lg:mb-0">
                  {benefit?.text}
                </div>
                <a
                  href={contactVal
                    .filter((item) => item.name === "Whatsapp")
                    .map((item) => item.url)}
                >
                  <div className="text-white mx-auto lg:mx-0 w-1/2 lg:w-auto lg:px-10 py-2 bg-gradient-to-r from-[#0E46A3] to-[#031736] rounded-lg">
                    <p className="text-center text-xs md:text-base">
                      Contact Us
                    </p>
                  </div>
                </a>
              </div>
            </span>
            <div className="flex-grow border-t border-gray-400"></div>
          </div>
          <div className="max-w-80 md:max-w-screen-sm lg:max-w-screen-xl mx-auto my-10">
            <div className="lg:flex flex-row justify-center items-center gap-5">
              {benefit?.data?.map((item, index) => (
                <div className="basis-1/3 flex items-center gap-2 md:w-1/2 m-auto pb-3">
                  <img
                    src={urlAPI + item[`footer_image_${index + 1}`]}
                    alt="wheel"
                    className="w-12 h-12 object-cover"
                  />
                  <p className="font-base">
                    {item[`footer_caption_${index + 1}`]}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default SingleNews;
